function applyThemeFromQueryIfEmbedded() {
  // Only run if embedded (iframe)
  if (window.self !== window.top) {
    const params = new URLSearchParams(window.location.search);
    const theme = params.get('theme');
    if (theme === 'dark' || theme === 'light') {
      if (theme === 'dark') {
        document.documentElement.classList.add('dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('theme', 'light');
      }
    }
  }
}

applyThemeFromQueryIfEmbedded();

import './recaptcha-hide-global.css';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Create the root and render the app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);